var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor"},[_c('Editor',{attrs:{"init":_vm.init,"disabled":_vm.disabled},model:{value:(_vm.editorValue),callback:function ($$v) {_vm.editorValue=$$v},expression:"editorValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }